import { ErrorMessage } from 'formik'

type FormElementProps = {
  htmlFor?: string
  label?: string
  children?: JSX.Element
  error?: string
  name?: string
  optional?: boolean
}

export default function FormElement({
  htmlFor,
  label,
  children,
  error,
  name,
  optional,
}: FormElementProps) {
  return (
    <div>
      {label && (
        <div className="flex flex-row space-x-2">
          <label
            htmlFor={htmlFor || name}
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            {label}
          </label>
          {optional && (
            <label className="block mb-2 text-sm font-normal text-gray-600">
              (optional)
            </label>
          )}
        </div>
      )}
      <div className="relative flex items-center">{children}</div>
      {name && !error ? (
        <ErrorMessage name={name}>
          {(msg) => (
            <div className="mt-1 text-error-700 text-xs absolute">{msg}</div>
          )}
        </ErrorMessage>
      ) : (
        error && <div className="mt-1 text-red-500 text-xs">{error}</div>
      )}
    </div>
  )
}
